module.exports = __webpack_public_path__ + "static/img/connect-tonecloud@2x.3d9b3bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-mini-guitar/connect-tonecloud@2x.png
// module id = oRD8
// module chunks = 13